import { useState } from 'react';
import type { AddCertificateModalProps, CertificateModalState } from './types';
import {
  ChooseCertificateAction,
  GenerateCertificate,
  UploadCertificateWithPassword,
  UploadPublicCertificate,
} from './components';
import { useAppDetailContext } from '../../../lib/detail';

const AddCertificatePanel: React.FC<AddCertificateModalProps> = ({ isOpen, close }) => {
  const { app, isSaml } = useAppDetailContext();
  const [modalState, setModalState] = useState<CertificateModalState>('choice');

  const closeAndReset = () => {
    setModalState('choice');
    close();
  };

  if (!isSaml) return <UploadPublicCertificate app={app} isOpen={isOpen} close={closeAndReset} />;

  switch (modalState) {
    case 'upload':
      return <UploadCertificateWithPassword app={app} isOpen={isOpen} close={closeAndReset} />;

    case 'generate':
      return <GenerateCertificate app={app} isOpen={isOpen} close={closeAndReset} />;

    case 'choice':
      return <ChooseCertificateAction setModalState={setModalState} isOpen={isOpen} close={closeAndReset} />;
  }
};

export default AddCertificatePanel;
